import _debounce from "lodash/debounce";
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { LOGIN_POPUP, LOGIN_FOR_FAVOURITES_TITLE } from 'swag-client-common/constants';
import { toggleFavouriteProduct } from 'swag-client-common/redux/favourite-products/favourite-products.actions';
import { ProductCardComponent } from '../../../../../page/components/product-card';
import { openProductFromCategoryEnable, setProductIdToUrl } from '../../../../../../redux/search-products/search-products.actions';
import { isProductFavouriteSelector } from '../../../../../../redux/favourite-products/favourite-products.selectors';
import { appliedFilterSelector, showSuperSpeedIconSelector, showProductLabelSelector } from '../../../../../../redux/product-listing/product-listing.selectors';
import { isAccumulatorSelector, inStockSelector, limitedEditionSelector, linkSelector, isOutOfStockSelector, isLabelCenteredSelector, showInStockCountSelector, showLimitedEditionCountdownSelector } from '../../../../../page/components/product-card/product-card.selectors';
const mapStateToProps = createStructuredSelector({
  appliedFilter: appliedFilterSelector,
  isFavourite: isProductFavouriteSelector,
  isAccumulator: isAccumulatorSelector,
  link: linkSelector,
  showSuperSpeedIcon: showSuperSpeedIconSelector,
  limitedEdition: limitedEditionSelector,
  inStock: inStockSelector,
  isOutOfStock: isOutOfStockSelector,
  isLabelCentered: isLabelCenteredSelector,
  showInStockCount: showInStockCountSelector,
  showProductLabel: showProductLabelSelector,
  showLimitedEditionCountdown: showLimitedEditionCountdownSelector
});
const mapDispatchToProps = (dispatch, props) => {
  const debouncedDispatch = _debounce(dispatch, 1000);
  return {
    onProductFavouriteClick: ({
      productId,
      nextIsFavourite,
      productAccumulatorId
    }) => {
      if (props.isLoggedIn) {
        debouncedDispatch(toggleFavouriteProduct({
          productId,
          nextIsFavourite,
          productAccumulatorId
        }));
      } else {
        dispatch(showPopup({
          popup: LOGIN_POPUP,
          title: LOGIN_FOR_FAVOURITES_TITLE
        }));
      }
    },
    onCategoryProductClick: id => {
      dispatch(setProductIdToUrl(id));
      dispatch(openProductFromCategoryEnable());
    }
  };
};
export const ListingProductCard = connect(mapStateToProps, mapDispatchToProps)(ProductCardComponent);